// extracted by mini-css-extract-plugin
export default {"gameBoard":"GameBoard_gameBoard__y5Hjd","top":"GameBoard_top__1129j","center":"GameBoard_center__lV39R","bottom":"GameBoard_bottom__RTZl3","cardPiles":"GameBoard_cardPiles__IKnCK"};